var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.974 16.605-.818 3.544c-.115.5-.555.851-1.07.851C10.214 21 3 13.786 3 4.916c0-.515.35-.956.852-1.07l3.544-.818a1.1 1.1 0 0 1 1.258.637l1.635 3.815a1.1 1.1 0 0 1-.315 1.281l-1.893 1.52a12.3 12.3 0 0 0 5.608 5.607l1.55-1.892c.305-.378.832-.51 1.282-.315l3.814 1.635c.46.241.758.776.639 1.289"
  })));
};
export default SvgPhone;